import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
//import MainFeaturedPost from './MainFeaturedPost';
import FeaturedPost from './FeaturedPost';
import posts from './posts/posts.js'

export default function Blog() {
  return (
    <Container maxWidth="lg">
      {/*<MainFeaturedPost post={mainFeaturedPost} />*/}
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography component="h2" variant="h1" style={{ textAlign: "center" }}>
            Blog Posts
          </Typography>
        </Grid>
        {posts.map((post) => (
          <FeaturedPost key={post.title} post={post} />
        ))}
      </Grid>
      <Grid container spacing={5} sx={{ mt: 3 }}>
        {/*<Main title="From the firehose" posts={posts} />*/}
      </Grid>
    </Container>
  );
}
